import currencyExchangeTemplate from './template/currency-exchange.html';
const DEFAULT_CURRENCY = 'EUR';

function routeProvider ($routeProvider) {
    $routeProvider
        .when('/', {
            template: currencyExchangeTemplate,
            controller: 'currencyExchangePageController',
            controllerAs: 'currencyExchangeVM',
            resolve: {
                availableCurrencies : ['currencyExchangeClient', 'country', 'language',
                    function(currencyExchangeClient, country, language) {
                        return Promise.all([
                                currencyExchangeClient.getSupportedCurrencies({ locale: 'lt' }),
                                currencyExchangeClient
                                    .getDefaultCountryCurrency({
                                        locale: language.getCurrentLanguage(),
                                        country_code: country.getCurrentCountry().toLowerCase()
                                    })
                            ]
                        ).then(
                            currency => {
                                let [supportedCurrencies, defaultCurrency] = currency;

                                return {
                                    supportedCurrencies,
                                    defaultCountryCurrency: supportedCurrencies.includes(defaultCurrency)
                                        ? defaultCurrency
                                        : DEFAULT_CURRENCY,
                                };
                            }
                        );
                    }],
                providers : ['currencyExchangeClient', 'country', 'language',
                    function(currencyExchangeClient, country, language) {
                        return currencyExchangeClient
                            .getSupportedProviders({
                                locale: language.getCurrentLanguage(),
                                country_code: country.getCurrentCountry().toLowerCase()
                            }).then(
                                (providers) => {
                                    return providers;
                                }
                            );
                }],
                'translations': ['translationLoader', function (translationLoader) {
                    return translationLoader.ensureTranslations('PayseraCurrencyExchangeBundle');
                }],
                currencyTranslations: ['currencyExchangeClient', 'language', function(currencyExchangeClient, language) {
                    return currencyExchangeClient.getCurrencyTranslations(language.getCurrentLanguage());
                }]
            }
        })
        .otherwise('/')
    ;
}

routeProvider.$inject = ['$routeProvider'];

export default routeProvider;
